import { render, staticRenderFns } from "./WaitingStatus.vue?vue&type=template&id=1bbba008"
import script from "./WaitingStatus.vue?vue&type=script&lang=js"
export * from "./WaitingStatus.vue?vue&type=script&lang=js"
import style0 from "./WaitingStatus.vue?vue&type=style&index=0&id=1bbba008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports